import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumenteRoutingModule } from './documente-routing.module';
import { DocumenteComponent } from './documente.component';
import { ReactiveFormsModule } from '@angular/forms';

// Angular Material Modules
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    declarations: [DocumenteComponent],
    imports: [
        CommonModule,
        DocumenteRoutingModule,
        ReactiveFormsModule,
        // Angular Material
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatStepperModule,
        MatProgressSpinnerModule,
        MatListModule,
        MatSelectModule,
        MatCheckboxModule
    ]
})
export class DocumenteModule { }
